import {SET_SPARES_CITIES_LIST} from "../../Actions/ActionConstants";

const CitiesListReducer = (state = null, action) => {
    if (action.type === SET_SPARES_CITIES_LIST) {
        return action.data;
    } else {
        return state;
    }
};
export default CitiesListReducer
